import { Root } from '@radix-ui/react-radio-group'
import { dataTestIds } from '@velasca/constants'
import { CartIcon } from '@velasca/icons/cart'
import { ErrorIcon } from '@velasca/icons/error'
import { LoadingIcon } from '@velasca/icons/loading'
import { SuccessIcon } from '@velasca/icons/success'
import type { Status } from '@velasca/types'
import { SansText } from '../SansText/SansText'
import { Icon, SizeItem } from './SizesGroup.styles'
import type { SizeItemProps, SizesGroupProps } from './SizesGroup.types'

const getIcon = (status: Status) => {
  switch (status) {
    case 'loading': {
      return <LoadingIcon />
    }
    case 'success': {
      return <SuccessIcon />
    }
    case 'error': {
      return <ErrorIcon />
    }
    default: {
      return null
    }
  }
}

export const SizesGroup = ({
  className = '',
  sizes,
  isRequired = false,
  status = 'idle',
  selectedSize,
  onSizeChange,
  isGiftCard = false,
  showUnavailableSizes = false,
}: SizesGroupProps): JSX.Element => {
  return (
    <Root
      name="id"
      className={className}
      required={isRequired}
      disabled={status === 'loading'}
      value={selectedSize ?? ''}
      onValueChange={onSizeChange}
    >
      {sizes.map(({ id, name, quantityAvailable }: SizeItemProps) => {
        const isSelected = id === selectedSize
        const isUnavailable = quantityAvailable === 0 && !showUnavailableSizes
        const idleSize = name || (
          <Icon>
            <CartIcon />
          </Icon>
        )
        const isSizeDisabled = isUnavailable && !isGiftCard

        return (
          <SizeItem
            key={id}
            value={id}
            disabled={isSizeDisabled}
            $isGiftCard={isGiftCard}
            data-testid={
              isSizeDisabled ? undefined : dataTestIds.SIZE_RADIO_BUTTON
            }
            className={`${
              isUnavailable && !isSelected && !isGiftCard ? 'unavailable' : ''
            } ${isSelected ? 'selected' : ''} ${status}`}
          >
            {status !== 'idle' && isSelected ? (
              <Icon>{getIcon(status)}</Icon>
            ) : (
              <SansText fontWeight="500" color="inherit" size="md">
                {idleSize}
              </SansText>
            )}
          </SizeItem>
        )
      })}
    </Root>
  )
}
